<template>
  <div>

    <head>
      <meta charset="utf-8" />
      <title>Login | PONA HEALTH-X System</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="PONA HEALTH-X - Community Based Health Insurance System" name="description" />
      <meta content="PONA HEALTH-X Team" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.svg">

      <!-- owl.carousel css -->
      <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">

      <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />

    </head>

    <body @contextmenu.prevent class="auth-body-bg">

    <div>
      <div class="container-fluid p-0">
        <div class="row g-0">

          <div class="col-xl-8 col-lg-8">
            <div class="auth-full-bg pt-lg-5 p-4">
              <div class="w-100">
                <div class="bg-overlay"></div>
                <div class="d-flex h-100 flex-column">

                  <div class="p-4 mt-auto">
                    <div class="row justify-content-center">
                      <div class="col-lg-7">
                        <div class="text-center">
                          <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" class="img mb-3" style="width: 510px;  border-radius: 16px; padding-bottom: 95px;padding-left: 75px; margin-left: 40px">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end col -->

          <div class="col-xl-4 col-md-4">
            <div class="auth-full-page-content p-md-5 p-4">
              <div class="w-100">

                <div class="d-flex flex-column h-100">
                  <div class="mb-4 mb-md-5">
                    <a class="d-block auth-logo">
                      <img src="https://pona.paysol.africa/logos/pona.png" alt="PONA HEALTH-X Logo" style="max-height: 200px; padding-left: 90px; ">
                    </a>
                  </div>
                  <div class="my-auto">

                    <div>
                      <h5 class="text-success">Welcome Back !</h5>
                      <p class="text-muted">Sign in to continue using the <strong>PONA HEALTH-X System</strong>
                      </p>
                    </div>

                    <div class="mt-4">
                      <div class="mb-3">
                        <label for="username" class="form-label">Username</label>
                        <input v-model="loginForm.username" type="text" class="form-control" id="username" placeholder="Enter your username">
                      </div>

                      <div class="mb-3">
                        <div class="float-end">
                          <a href="#" @click="showForgotPassword = true" class="text-muted">Forgot password?</a>
                        </div>
                        <label class="form-label">Password</label>
                        <div class="input-group auth-pass-inputgroup">
                          <input v-model="loginForm.password" :type="showPassword ? 'text' : 'password'" class="form-control" placeholder="Enter password" aria-label="Password" aria-describedby="password-addon">
                          <button class="btn btn-light" type="button" id="password-addon" @click="togglePassword">
                            <i :class="showPassword ? 'mdi mdi-eye-off-outline' : 'mdi mdi-eye-outline'"></i>
                          </button>
                        </div>
                      </div>

                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="remember-check" v-model="rememberMe">
                        <label class="form-check-label" for="remember-check">
                          Remember me
                        </label>
                      </div>

                      <div v-if="alert.success" class="alert alert-success" role="alert">
                        {{message}}
                      </div>

                      <div v-if="alert.info" class="alert alert-primary" role="alert">
                        {{message}}
                      </div>

                      <div v-if="alert.failed" class="alert alert-danger" role="alert">
                        {{message}}
                      </div>

                      <div class="mt-3 d-grid">
                        <button @click="login" :disabled="loading" class="btn btn-primary waves-effect waves-light" type="submit">
                          <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          {{ loading ? 'Signing In...' : 'Log In' }}
                        </button>
                      </div>
                    </div>

                    <!-- Forgot Password Modal -->
                    <div v-if="showForgotPassword" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
                      <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title">Reset Password</h5>
                            <button type="button" class="btn-close" @click="showForgotPassword = false"></button>
                          </div>
                          <div class="modal-body">
                            <div class="mb-3">
                              <label for="reset-email" class="form-label">Email Address</label>
                              <input v-model="forgotPasswordEmail" type="email" class="form-control" id="reset-email" placeholder="Enter your email">
                            </div>
                            <div v-if="forgotPasswordAlert.success" class="alert alert-success" role="alert">
                              {{forgotPasswordMessage}}
                            </div>
                            <div v-if="forgotPasswordAlert.failed" class="alert alert-danger" role="alert">
                              {{forgotPasswordMessage}}
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" @click="showForgotPassword = false">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="forgotPassword" :disabled="forgotPasswordLoading">
                              <span v-if="forgotPasswordLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              {{ forgotPasswordLoading ? 'Sending...' : 'Send Reset Link' }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="mt-4 mt-md-5 text-center">
                    <p class="mb-0">©
                      2025 PONA HEALTH-X. All rights reserved.
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <!-- end col -->
        </div>
        <!-- end row -->
      </div>
      <!-- end container-fluid -->
    </div>

    </body>

  </div>
</template>

<script>
/* eslint-disable */
import {authUrl, executeJson, getRight} from "@/api";
import router from "@/router";

export default {
  name: "PonaHealthLoginPage",
  data() {
    return {
      loading: false,
      showPassword: false,
      showForgotPassword: false,
      rememberMe: false,

      // Device details
      deviceDetails: '',
      os: '',
      browser: '',
      screenResolution: '',
      cpuCores: '',
      memory: '',

      // Login form data
      loginForm: {
        username: '',
        password: ''
      },

      // Alert states
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: '',

      // Forgot password
      forgotPasswordEmail: '',
      forgotPasswordLoading: false,
      forgotPasswordAlert: {
        success: false,
        failed: false
      },
      forgotPasswordMessage: ''
    }
  },
  mounted() {
    this.getDeviceDetails()
    this.checkRememberedLogin()
  },
  methods: {
    getDeviceDetails() {
      // Operating System
      if (navigator.userAgent.indexOf('Win') !== -1) this.os = 'Windows';
      else if (navigator.userAgent.indexOf('Mac') !== -1) this.os = 'MacOS';
      else if (navigator.userAgent.indexOf('Linux') !== -1) this.os = 'Linux';
      else this.os = 'Unknown';

      // Browser
      if (navigator.userAgent.indexOf('Chrome') !== -1) this.browser = 'Chrome';
      else if (navigator.userAgent.indexOf('Firefox') !== -1) this.browser = 'Firefox';
      else if (navigator.userAgent.indexOf('Safari') !== -1) this.browser = 'Safari';
      else if (navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode) this.browser = 'Internet Explorer';
      else this.browser = 'Unknown';

      // Screen Resolution
      this.screenResolution = `${window.screen.width} x ${window.screen.height}`;

      // CPU Cores
      this.cpuCores = navigator.hardwareConcurrency || 'Unknown';

      // Memory
      this.memory = (navigator.deviceMemory || 'Unknown');

      this.deviceDetails = `OS: ${this.os} | Browser: ${this.browser} | Screen: ${this.screenResolution} | CPU Cores: ${this.cpuCores} | Memory: ${this.memory}GB`
    },

    checkRememberedLogin() {
      const rememberedUsername = localStorage.getItem('rememberedUsername')
      if (rememberedUsername) {
        this.loginForm.username = rememberedUsername
        this.rememberMe = true
      }
    },

    togglePassword() {
      this.showPassword = !this.showPassword
    },

    clearAlerts() {
      this.alert.success = false
      this.alert.info = false
      this.alert.failed = false
    },

    login() {
      // Validation
      if (!this.loginForm.username || !this.loginForm.password) {
        this.alert.failed = true
        this.message = 'Please enter both username and password'
        return
      }

      this.message = "Authorizing..."
      this.alert.failed = false
      this.alert.info = true

      const data = {
        "function": "login",
        "username": this.loginForm.username,
        "password": this.loginForm.password,
        "deviceDetails": this.deviceDetails
      };

      executeJson(data, authUrl)
          .then((res) => {
            this.alert.info = false

            if (res.data.success) {
              // Store authentication token
              localStorage.setItem("authToken", res.data.data.token)

              // Store user information in sessionStorage - only what exists in the API response
              sessionStorage.setItem("isLoggedIn", true)
              sessionStorage.setItem("userId", res.data.data.user.userId)
              sessionStorage.setItem("username", res.data.data.user.username)
              sessionStorage.setItem("fullName", res.data.data.user.fullName)
              sessionStorage.setItem("email", res.data.data.user.email)
              sessionStorage.setItem("category", res.data.data.user.category)
              sessionStorage.setItem("accessScope", res.data.data.user.accessScope)

              // Store selected roles information
              if (res.data.data.selectedRoles) {
                sessionStorage.setItem("selectedRoles", JSON.stringify(res.data.data.selectedRoles))

                // Extract role names for easy access
                const roleNames = res.data.data.selectedRoles.map(role => role.role)
                sessionStorage.setItem("userRoles", JSON.stringify(roleNames))
              }

              // Remember username if checkbox is checked
              if (this.rememberMe) {
                localStorage.setItem('rememberedUsername', this.loginForm.username)
              } else {
                localStorage.removeItem('rememberedUsername')
              }

              this.message = res.data.message
              this.alert.success = true

              router.push('dashboard')

            } else {
              sessionStorage.setItem("isLoggedIn", false)
              this.alert.failed = true
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.alert.info = false
            this.alert.failed = true
            this.message = e.message
          });
    },

    async forgotPassword() {
      if (!this.forgotPasswordEmail) {
        this.forgotPasswordAlert.failed = true
        this.forgotPasswordMessage = 'Please enter your email address'
        return
      }

      if (!this.isValidEmail(this.forgotPasswordEmail)) {
        this.forgotPasswordAlert.failed = true
        this.forgotPasswordMessage = 'Please enter a valid email address'
        return
      }

      this.forgotPasswordLoading = true
      this.forgotPasswordMessage = "Sending reset link..."

      const data = {
        "function": "forgotPassword",
        "email": this.forgotPasswordEmail
      };

      executeJson(data, authUrl)
          .then((res) => {
            this.forgotPasswordLoading = false

            if (res.data.success) {
              this.forgotPasswordAlert.success = true
              this.forgotPasswordAlert.failed = false
              this.forgotPasswordMessage = res.data.message

              // Clear email field and close modal after success
              setTimeout(() => {
                this.forgotPasswordEmail = ''
                this.showForgotPassword = false
                this.forgotPasswordAlert.success = false
              }, 3000)
            } else {
              this.forgotPasswordAlert.failed = true
              this.forgotPasswordAlert.success = false
              this.forgotPasswordMessage = res.data.message
            }
          })
          .catch((e) => {
            this.forgotPasswordLoading = false
            this.forgotPasswordAlert.failed = true
            this.forgotPasswordAlert.success = false
            this.forgotPasswordMessage = e.message || 'An error occurred. Please try again.'
          });
    },

    showAlert(type, message) {
      this.clearAlerts()
      this.alert[type] = true
      this.message = message

      // Auto-hide success/info alerts after 5 seconds
      if (type === 'success' || type === 'info') {
        setTimeout(() => {
          this.clearAlerts()
        }, 5000)
      }
    },

    isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return emailRegex.test(email)
    }
  }
}
</script>

<style scoped>
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

.modal.show {
  display: block !important;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.auth-pass-inputgroup .btn {
  border-left: 0;
}

.auth-pass-inputgroup .form-control {
  border-right: 0;
}

.auth-pass-inputgroup .form-control:focus {
  box-shadow: none;
  border-color: #ced4da;
}

.auth-pass-inputgroup .form-control:focus + .btn {
  border-color: #80bdff;
}
</style>